module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-center"
  }, [_c('b', [_vm._v("Praise for Catherine Asaro")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_vm._v("“Asaro’s Skolian saga is now nearly as long and in many ways as compelling as Dune, if not more so, featuring a multitude of stronger female characters.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-right"
  }, [_vm._v("—"), _c('i', [_vm._v("Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_vm._v("“Asaro plants herself firmly into that grand SF tradition of future history franchises favored by luminaries like Heinlein, Asimov, Herbert, Anderson, Dickson, Niven, Cherryh, and Baxter. It really seems to me that any future mention of this stefnal lineage must include her name as a worthy exemplar.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-right"
  }, [_vm._v("—"), _c('i', [_vm._v("Locus")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_vm._v("“Catherine Asaro’s Saga of the Skolian Empire may be the most important and entertaining science fiction series to originate in the 1990s.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-right"
  }, [_vm._v("—Cynthia Ward, author of "), _c('i', [_vm._v("The Adventure of the Golden Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-"
  }, [_vm._v("“Asaro’s portrait of interstellar intrigue, weird socio-political customs and galactic history has come to approach the neighborhood of such classics as Frank Herbert’s Dune series.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent--Body-right"
  }, [_vm._v("—"), _c('i', [_vm._v("Booklist")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72ca32ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/praise.vue
// module id = 72
// module chunks = 0